import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Output {
  id: string;
  name: string;
  description?: string;
  quantity: number;
  unit: string;
  created_at: string;
}

interface OutputsState {
  byId: Record<string, Output>;
  allIds: string[];
  isLoading: boolean;
  error: string | null;
}

const initialState: OutputsState = {
  byId: {},
  allIds: [],
  isLoading: false,
  error: null,
};

const outputsSlice = createSlice({
  name: 'outputs',
  initialState,
  reducers: {
    setOutputs: (state, action: PayloadAction<Output[]>) => {
      state.byId = {};
      state.allIds = [];
      action.payload.forEach((output) => {
        state.byId[output.id] = output;
        state.allIds.push(output.id);
      });
    },
    addOutput: (state, action: PayloadAction<Output>) => {
      const output = action.payload;
      state.byId[output.id] = output;
      if (!state.allIds.includes(output.id)) {
        state.allIds.push(output.id);
      }
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const { setOutputs, addOutput, setLoading, setError } = outputsSlice.actions;

export default outputsSlice.reducer;
